import { render } from "./temporaryRecord.vue?vue&type=template&id=4ad14f6d"
import script from "./temporaryRecord.vue?vue&type=script&lang=js"
export * from "./temporaryRecord.vue?vue&type=script&lang=js"

import "./temporaryRecord.vue?vue&type=style&index=0&id=4ad14f6d&lang=scss"

import exportComponent from "D:\\A-wy-work\\wy-vue-source\\wy-saas\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__